/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "feedbacksurveys": {
        "nested": {
          "SurveyResponse": {
            "fields": {
              "surveyResponseMetadata": {
                "type": ".squareup.feedbacksurveys.SurveyResponse.SurveyResponseMetadata",
                "id": 1,
                "rule": "optional"
              },
              "questionResponse": {
                "type": ".squareup.feedbacksurveys.QuestionResponse",
                "id": 2,
                "rule": "repeated"
              }
            },
            "nested": {
              "SurveyResponseMetadata": {
                "fields": {
                  "responder": {
                    "type": ".squareup.feedbacksurveys.Responder",
                    "id": 1,
                    "rule": "optional"
                  },
                  "surveyToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "surveyResponseToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "dismissed": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "createdAtMs": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "updatedAtMs": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "QuestionResponse": {
            "fields": {
              "questionResponseToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "questionToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "questionPrompt": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "createdAtMs": {
                "type": "int64",
                "id": 5,
                "rule": "optional"
              },
              "updatedAtMs": {
                "type": "int64",
                "id": 6,
                "rule": "optional"
              },
              "freeFormResponse": {
                "type": ".squareup.feedbacksurveys.QuestionResponse.FreeFormResponse",
                "id": 4
              },
              "singleSelectResponse": {
                "type": ".squareup.feedbacksurveys.QuestionResponse.SingleSelectResponse",
                "id": 7
              },
              "multipleSelectResponse": {
                "type": ".squareup.feedbacksurveys.QuestionResponse.MultipleSelectResponse",
                "id": 8
              },
              "csatResponse": {
                "type": ".squareup.feedbacksurveys.QuestionResponse.CsatResponse",
                "id": 9
              }
            },
            "nested": {
              "FreeFormResponse": {
                "fields": {
                  "textResponse": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SingleSelectResponse": {
                "fields": {
                  "choice": {
                    "type": ".squareup.feedbacksurveys.Choice",
                    "id": 1,
                    "rule": "optional"
                  },
                  "questionChoice": {
                    "type": ".squareup.feedbacksurveys.Choice",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "MultipleSelectResponse": {
                "fields": {
                  "choice": {
                    "type": ".squareup.feedbacksurveys.Choice",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "questionChoice": {
                    "type": ".squareup.feedbacksurveys.Choice",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "CsatResponse": {
                "fields": {
                  "choice": {
                    "type": ".squareup.feedbacksurveys.Choice",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "answer": {
                "oneof": ["freeFormResponse", "singleSelectResponse", "multipleSelectResponse", "csatResponse"]
              }
            }
          },
          "CreateResponseRequest": {
            "fields": {
              "surveyResponse": {
                "type": ".squareup.feedbacksurveys.SurveyResponse",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "CreateResponseResponse": {
            "fields": {
              "surveyResponseToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.SurveyResponse && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.SurveyResponse?.nested?.SurveyResponseMetadata && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.QuestionResponse && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.QuestionResponse?.nested?.FreeFormResponse && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.QuestionResponse?.nested?.SingleSelectResponse && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.QuestionResponse?.nested?.MultipleSelectResponse && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.QuestionResponse?.nested?.CsatResponse && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.CreateResponseRequest && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.CreateResponseResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SurveyResponse @ squareup/feedbacksurveys/survey_response.proto at 11:1
 */
export const SurveyResponse = $root.lookupType('squareup.feedbacksurveys.SurveyResponse');
fixType(SurveyResponse);
Builder.createAndAttachToType(SurveyResponse);
/**
 * SOURCE SurveyResponseMetadata @ squareup/feedbacksurveys/survey_response.proto at 12:3
 */
SurveyResponse.SurveyResponseMetadata = $root.lookupType('squareup.feedbacksurveys.SurveyResponse.SurveyResponseMetadata');
fixType(SurveyResponse.SurveyResponseMetadata);
Builder.createAndAttachToType(SurveyResponse.SurveyResponseMetadata);
/**
 * SOURCE QuestionResponse @ squareup/feedbacksurveys/survey_response.proto at 52:1
 */
export const QuestionResponse = $root.lookupType('squareup.feedbacksurveys.QuestionResponse');
fixType(QuestionResponse);
Builder.createAndAttachToType(QuestionResponse);
/**
 * SOURCE FreeFormResponse @ squareup/feedbacksurveys/survey_response.proto at 64:3
 */
QuestionResponse.FreeFormResponse = $root.lookupType('squareup.feedbacksurveys.QuestionResponse.FreeFormResponse');
fixType(QuestionResponse.FreeFormResponse);
Builder.createAndAttachToType(QuestionResponse.FreeFormResponse);
/**
 * SOURCE SingleSelectResponse @ squareup/feedbacksurveys/survey_response.proto at 68:3
 */
QuestionResponse.SingleSelectResponse = $root.lookupType('squareup.feedbacksurveys.QuestionResponse.SingleSelectResponse');
fixType(QuestionResponse.SingleSelectResponse);
Builder.createAndAttachToType(QuestionResponse.SingleSelectResponse);
/**
 * SOURCE MultipleSelectResponse @ squareup/feedbacksurveys/survey_response.proto at 76:3
 */
QuestionResponse.MultipleSelectResponse = $root.lookupType('squareup.feedbacksurveys.QuestionResponse.MultipleSelectResponse');
fixType(QuestionResponse.MultipleSelectResponse);
Builder.createAndAttachToType(QuestionResponse.MultipleSelectResponse);
/**
 * SOURCE CsatResponse @ squareup/feedbacksurveys/survey_response.proto at 84:3
 */
QuestionResponse.CsatResponse = $root.lookupType('squareup.feedbacksurveys.QuestionResponse.CsatResponse');
fixType(QuestionResponse.CsatResponse);
Builder.createAndAttachToType(QuestionResponse.CsatResponse);
/**
 * SOURCE CreateResponseRequest @ squareup/feedbacksurveys/survey_response.proto at 112:1
 */
export const CreateResponseRequest = $root.lookupType('squareup.feedbacksurveys.CreateResponseRequest');
fixType(CreateResponseRequest);
Builder.createAndAttachToType(CreateResponseRequest);
/**
 * SOURCE CreateResponseResponse @ squareup/feedbacksurveys/survey_response.proto at 116:1
 */
export const CreateResponseResponse = $root.lookupType('squareup.feedbacksurveys.CreateResponseResponse');
fixType(CreateResponseResponse);
Builder.createAndAttachToType(CreateResponseResponse);